import { render, staticRenderFns } from "./LogInPage.vue?vue&type=template&id=4b5d6358&scoped=true"
import script from "./LogInPage.vue?vue&type=script&lang=js"
export * from "./LogInPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d6358",
  null
  
)

export default component.exports